import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

export const academyApi: any = createApi({
  reducerPath: "academyApi",
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getAcademyHomeData: builder.query<
      any,
      { type: string; limit?: number; offset?: number }
    >({
      query: ({
        type,
        limit,
        offset,
      }: {
        type: string;
        limit?: number;
        offset?: number;
      }) => {
        const params = new URLSearchParams();
        if (limit !== undefined) params.append("limit", limit.toString());
        if (offset !== undefined) params.append("offset", offset.toString());

        return {
          url: `academy/${type}?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getAcademyCourseDetails: builder.query<any, void>({
      query: (newPost: any) => {
        return {
          url: `academy/course/${newPost.courseId}`,
          method: "GET",
        };
      },
    }),
    getAcademyCourseModuleDetails: builder.query<any, void>({
      query: (newPost: any) => {
        return {
          url: `academy/course/module/${newPost.moduleId}`,
          method: "GET",
        };
      },
    }),
    getAcademyCourseModuleEpisodeDetails: builder.query<any, void>({
      query: (newPost: any) => {
        return {
          url: `academy/course/module/episode/${newPost.episodeId}`,
          method: "GET",
        };
      },
    }),
    getModulePlayerDetails: builder.query<any, { episodeId: string }>({
      query: ({ episodeId }) => {
        return {
          url: `/academy/episode/${episodeId}/play`,
          method: "GET",
        };
      },
    }),
    getQuizDetails: builder.query<any, { quizId: string }>({
      query: ({ quizId }) => {
        return {
          url: `/quiz/${quizId}`,
          method: "GET",
        };
      },
    }),
    postAcademyProgress: builder.mutation<any, { body: any }>({
      query: ({ body }) => ({
        url: `/academy/progress`,
        method: "POST",
        data: body,
      }),
    }),
    postQuizResult: builder.mutation<any, { quizId: string; body: any }>({
      query: ({ quizId, body }) => ({
        url: `/quiz/result/${quizId}`,
        method: "POST",
        data: body,
      }),
    }),
    getCourseRewards: builder.query<any, { courseId: string }>({
      query: ({ courseId }) => ({
        url: `/academy/course/${courseId}/badges`,
        method: "GET",
      }),
    }),
    getCourseCertificate: builder.query<any, { courseId: string }>({
      query: ({ courseId }) => ({
        url: `/academy/course/${courseId}/certificate`,
        method: "GET",
      }),
    }),
    getLivestreamPlayerDetails: builder.query<any, { livestreamId: string }>({
      query: ({ livestreamId }) => {
        return {
          url: `/academy/livestream/${livestreamId}`,
          method: "GET",
        };
      },
    }),
    getLastWatchedEpisode: builder.query<any, null>({
      query: () => {
        return {
          url: `/academy/last-watched-episode`,
          method: "GET",
        };
      },
    }),
    getNextEpisode: builder.query<any, { episodeId: string }>({
      query: ({ episodeId }) => {
        return {
          url: `/academy/episode/${episodeId}/next-episode`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useLazyGetAcademyHomeDataQuery,
  useGetAcademyHomeDataQuery,
  useLazyGetAcademyCourseDetailsQuery,
  useLazyGetAcademyCourseModuleDetailsQuery,
  useLazyGetAcademyCourseModuleEpisodeDetailsQuery,
  useLazyGetModulePlayerDetailsQuery,
  useLazyGetQuizDetailsQuery,
  usePostAcademyProgressMutation,
  usePostQuizResultMutation,
  useLazyGetCourseRewardsQuery,
  useLazyGetCourseCertificateQuery,
  useLazyGetLivestreamPlayerDetailsQuery,
  useLazyGetLastWatchedEpisodeQuery,
  useLazyGetNextEpisodeQuery,
} = academyApi;
